import imgYuthica1 from "./img-yuthica (1).webp";
import imgYuthica2 from "./img-yuthica (2).webp";
import imgYuthica3 from "./img-yuthica (3).webp";
import imgYuthica4 from "./img-yuthica (4).webp";

const imgYuthica = [imgYuthica1, imgYuthica2, imgYuthica3, imgYuthica4];

export default imgYuthica;
